import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppColorProgressBarComponent } from './color-progressbar.component';

@NgModule({
  declarations: [AppColorProgressBarComponent],
  imports: [CommonModule],
  exports: [AppColorProgressBarComponent]
})
export class AppColorProgressBarModule {}
